// extracted by mini-css-extract-plugin
export default {"composition-table":"ProductCompositionTable_composition-table__ChpVx","no-data":"ProductCompositionTable_no-data__h02s0"};